import React from 'react';

const IconClose = props => (<svg viewBox="0 0 20 20" width="20px" height="20px" {...props}>
  <path fill="#ffffff" d="M19.447 0.552L19.447 0.552c-0.736-0.736-1.931-0.736-2.666 0L9.999 7.333L3.218 0.552 c-0.736-0.736-1.93-0.736-2.666 0l0 0c-0.736 0.736-0.736 1.931 0 2.667L7.333 10l-6.781 6.781c-0.736 0.737-0.736 1.93 0 2.666l0 0 c0.736 0.736 1.93 0.736 2.666 0l6.781-6.781l6.782 6.781c0.735 0.736 1.93 0.736 2.666 0l0 0c0.736-0.736 0.736-1.929 0-2.666 L12.666 10l6.781-6.781C20.184 2.482 20.184 1.288 19.447 0.552z" />
</svg>);

export default IconClose;
